// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"wca-z","subtitle":"xca-z","wrapper":"yca-z","leftArrow":"zca-z","rightArrow":"Aca-z"};